module.exports = __webpack_public_path__ + "static/img/MIX2500_6.67d0efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MIX2500_6.png
// module id = +ZuL
// module chunks = 1